import { Button, Typography } from '@material-ui/core';

const Connect = ({ onClick }: any) => (
  <div style={{ marginBottom: "40px"}}>
    <Typography variant="h5">Manage your vehicle(s) connection</Typography>
    <Button variant="outlined" color="primary" onClick={onClick} style={{marginTop:'20px'}}>Connect</Button>
  </div>
);

export { Connect }